// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CartCtAs: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M41.2 26.2l1.4-13.5c0-.3-.1-.6-.3-.9s-.5-.4-.8-.4L9.8 9.6l-.5-2.7c-.1-.6-.6-1-1.1-1H2.5c-.6 0-1.1.5-1.1 1.2 0 .6.5 1.2 1.1 1.2h4.8L12 32.5c-.3.6-.5 1.2-.5 1.9 0 2.1 1.6 3.7 3.5 3.7s3.5-1.7 3.5-3.7c0-.5-.1-1-.3-1.4h16.2c-.2.4-.3.9-.3 1.4 0 2.1 1.6 3.7 3.5 3.7s3.5-1.7 3.5-3.7c0-2.1-1.6-3.7-3.5-3.7H13.9l-.6-3.2h26.9c.5-.2.9-.7 1-1.3zm-26.1 9.5c-.7 0-1.3-.6-1.3-1.4 0-.8.6-1.4 1.3-1.4s1.3.6 1.3 1.4c-.1.8-.6 1.4-1.3 1.4zm22.6 0c-.7 0-1.3-.6-1.3-1.4 0-.8.6-1.4 1.3-1.4s1.3.6 1.3 1.4c-.1.7-.6 1.4-1.3 1.4zM12.8 24.9l-2.5-13 30 1.7-1.1 11.2H12.8z"/></svg>;
};

export default React.memo(CartCtAs);
